import React from "react";
import { Modal, Button, Input, Checkbox, message } from "antd";
import { Link } from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import UserApplicationPresenter from "../../.gen/presenter/UserApplicationPresenter";
import ApplicationPresenter from "../../.gen/presenter/ApplicationPresenter";

export default class IdInfo extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            IdInfoModal: false,
            certNo: "",
        };
        this.userApplicationPresenter = new UserApplicationPresenter(this);
    }

    componentDidMount() {
    }

    render() {
        return <>
            <Modal
                title="实名认证"
                visible={this.props.PmId}
                destroyOnClose={true}
                onOk={() => {
                    this.setState({ loading: true });
                    if (this.state.checked) {
                        if (this.state.certNo.length == 18) {
                            this.userApplicationPresenter.realNameAuth({}, { certNo: this.state.certNo }, res => {
                                if (res.code == 0) {
                                    this.props._doLoginRedirect(this.props.PmId, true);
                                    this.setState({
                                        IdInfoModal: false,
                                        certNo: "",
                                        loading: false,
                                        protocol: false,
                                        checkedErr: false
                                    });
                                    window._workbench._user.realNameAuth = 1;
                                    this.props.cancel();
                                } else {
                                    console.log(res);
                                    message.error(res.message || res.msg);
                                    this.setState({ loading: false });
                                }
                            });
                            this.setState({ loading: false });
                        } else {
                            this.setState({ certNoErr: true, loading: false });
                        }
                    } else {
                        this.setState({ checkedErr: true, loading: false });
                    }
                }}
                confirmLoading={this.state.loading}
                onCancel={() => { this.props.cancel() }}
            >
                <div style={{ display: "inline-block", width: 60, marginRight: 10 }}>真实姓名:</div>
                <div style={{ display: "inline-block", width: "calc(100% - 70px)" }}>{window._workbench._user ? window._workbench._user.name : ""}</div>
                <div style={{ height: 20 }}></div>
                <div style={{ display: "inline-block", width: 60, marginRight: 10 }}>身份证号:</div>
                <div style={{ display: "inline-block", width: "calc(100% - 70px)" }}>
                    <Input style={{ width: "100%" }} onChange={e => {
                        this.setState({ certNo: e.target.value, certNoErr: false });
                    }} />
                </div>
                <div style={{ color: "red", display: this.state.certNoErr ? "block" : "none" }}>请输入正确身份证号</div>
                <div style={{ height: 20 }}></div>
                <Checkbox onChange={e => {
                    let checked = e.target.checked;
                    if (checked) {
                        this.setState({ checkedErr: false });
                    }
                    this.setState({ checked });
                }}>同意
                </Checkbox>
                <span style={{ cursor: "pointer", color: "#1961ac" }} onClick={() => {
                    this.setState({ protocol: true });
                }}>用户服务协议及隐私保护政策</span>
                <div style={{ color: "red", display: this.state.checkedErr ? "block" : "none" }}>需同意用户服务协议及隐私保护政策</div>
            </Modal>
            <Modal
                title="用户服务协议及隐私保护政策"
                visible={this.state.protocol}
                destroyOnClose={true}
                onCancel={() => { this.setState({ protocol: false }) }}
                footer={[
                    <Button key="back" onClick={() => {
                        this.setState({ protocol: false })
                    }}>
                        关闭
                    </Button>,
                ]}
            >
                <p style={{ fontSize: 16, fontWeight: 900 }}>1. 个人信息的收集、使用和保护：</p>
                <p style={{ textIndent: "2em" }}>尊敬的用户，欢迎注册使用盛云科技有限公司"数字盛云"统一门户管理系统，该管理系统现已实现银企互联，为了保证您的资金安全，根据国家相关规定，注册使用本管理系统需要进行实名认证，请认真填写相关信息并保证信息的真实性，以便我们能为您提供更加安全和贴心的服务。本网站仅在符合法律法规规定的情况下收集、使用您的个人信息，并且采取必要的安全措施进行保护，不会未经您的明示同意将您的个人信息提供给任何第三方，除非符合法律法规规定的情况。</p>
                <p style={{ fontSize: 16, fontWeight: 900 }}>2. Cookie 和 IP 地址的收集和使用：</p>
                <p style={{ textIndent: "2em" }}>为了提高用户的体验和服务，本网站会收集和使用Cookie和IP地址等信息，但本网站不会通过Cookie和IP地址等信息对用户进行个人信息收集或跟踪。</p>
                <p style={{ fontSize: 16, fontWeight: 900 }}>3. 安全措施：</p>
                <p style={{ textIndent: "2em" }}>本网站采用各种技术手段、安全保护措施，保护您的个人信息不被未经授权的访问、泄露、滥用、修改、损坏、丢失等情况发生。</p>
                <p style={{ fontSize: 16, fontWeight: 900 }}>5. 修改隐私政策：</p>
                <p style={{ textIndent: "2em" }}>本网站有权在任何时候修改本隐私政策，修改后的隐私政策将在本网站上公布生效。</p>
            </Modal>
        </>
    }
}